import React, { useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import "../../css/Detail/detailHeader.css";
import shareSVG from '../../assets/icons/svg/share.svg';
import { ReactComponent as DotSVG } from '../../assets/icons/svg/dot.svg';
import { useUser } from '../../contexts/UserContext';
import SaveButton from '../Common-components/Button/SaveButton';

function DetailHeader({
  productId,
  productCode,
  // productName,
  // productShipName,
  productTitle,
  productThumbnail,
  productParlors,
  productCabinTypes,
  productEvent
}) {
  const handleShareClick = () => {
    alert({
      title: '공유하기',
      content: <p>공유하기 버튼 클릭됨</p>,
    });
  };

  const roomRows = useMemo(() => {
    const parsePrice = value => {
      if (value === null || value === undefined || value === '') return null;
      if (typeof value === 'number') return Number.isFinite(value) ? value : null;
      const numeric = Number(String(value).replace(/,/g, ''));
      return Number.isFinite(numeric) ? numeric : null;
    };
    const leadRaw = productEvent?.leadprice ?? productEvent?.leaprice;
    const leadPrice = parsePrice(leadRaw);
    const hasLeadPrice = leadPrice !== null && leadPrice > 0;

    const typeMapping = { inside: '인사이드', outside: '오션뷰', balcony: '발코니', suite: '스위트' };
    const safeParlorPrices = Array.isArray(productParlors) ? productParlors : [];
    const priceMap = safeParlorPrices.reduce((acc, cur) => {
      if (!cur?.name) return acc;
      const key = cur.name.trim();
      acc[key] = parsePrice(cur.price);
      return acc;
    }, {});

    const uniqueParlorsMap = new Map();
    const cabinTypes = Array.isArray(productCabinTypes) ? productCabinTypes : [];

    if (cabinTypes.length > 0) {
      cabinTypes.forEach(cabin => {
        const baseType = (cabin.cabintype || '').toLowerCase();
        const nameKr = typeMapping[baseType] || cabin.cabintype_ko || cabin.cabintype;
        if (!nameKr || uniqueParlorsMap.has(nameKr)) return;

        const rawPrice = priceMap[nameKr] ?? null;
        uniqueParlorsMap.set(nameKr, {
          cabintype: nameKr,
          price: rawPrice !== null
            ? (rawPrice / 2).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD'
              })
            : (hasLeadPrice ? '$' : '마감'),
        });
      });
    } else {
      safeParlorPrices.forEach(parlor => {
        const type = parlor.name;
        if (!type || uniqueParlorsMap.has(type)) return;

        const rawPrice = parsePrice(parlor.price);
        uniqueParlorsMap.set(type, {
          cabintype: type,
          price: rawPrice !== null
            ? (rawPrice / 2).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD'
              })
            : (hasLeadPrice ? '$' : '마감'),
        });
      });
    }

    if (uniqueParlorsMap.size === 0) return [];

    // 같은 선실 타입 중복 제거 후 2개씩 묶어 그리드 행으로 사용
    const filteredParlors = Array.from(uniqueParlorsMap.values());
    const rows = [];
    for (let i = 0; i < filteredParlors.length; i += 2) {
      // 선실 정보는 한 행에 최대 두 칸씩 보여줌
      rows.push(filteredParlors.slice(i, i + 2));
    }
    return rows;
  }, [productParlors, productCabinTypes, productEvent]);

  return (
    <div className="detail-header">
      <div
        className="thumnail-image"
        style={{
          backgroundImage: `url(${productThumbnail})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />

      <div className="thumnail-info">
        <div className="thumnail-info-header">
          <div className="info-header-wrapper">
            <div className="info-header-question-code">
              <p>항차 코드</p>
              <p>{productCode}</p>
            </div>
            <div className="info-header-btn-wrapper">
              <SaveButton 
                size='M'
                name='저장하기'
                className='save_btn'
                id={productId}
              />
              <button type="button" className="share_btn" onClick={handleShareClick}>
                <img src={shareSVG} alt="공유하기" />
                <span>공유하기</span>
              </button>
            </div>
          </div>

          {/* <h2 className="info-header-title">{productShipName} · {productName}</h2> */}
          <h2 className="info-header-title">
            <span>{productTitle.startDate} 출발</span>
            <span>{productTitle.sailRegion} 크루즈 여행</span>
            <span>{productTitle.sailNights}박 {Number(productTitle.sailNights) + 1}일</span>
            <span>{productTitle.cruiseName}</span>
          </h2>
        </div>

        <div className="thumnail-info-body">
          <div className="info-price-info">
            <h2>2인 1실 기준, 1인 최저 요금</h2>

            <div className="grid">
              {productParlors == null ? (
                <p>선실 정보를 가져오고 있습니다.</p>
              ) : roomRows && roomRows.length > 0 ? (
                roomRows.map((row, rowIdx) => (
                  <div className="grid-row" key={rowIdx}>
                    <div className="grid-cell">
                      <span className="grid-name">{row[0].cabintype}</span>
                      <span className="grid-price">{row[0].price}</span>
                    </div>
                    {row[1] && <div className="grid-divider" />}
                    {row[1] && (
                      <div className="grid-cell">
                        <span className="grid-name">{row[1].cabintype}</span>
                        <span className="grid-price">{row[1].price}</span>
                      </div>
                    )}
                  </div>
                ))
              ) : (
                <p>선실 정보가 없습니다.</p>
              )}
            </div>
          </div>

          <div className="info-price-event">
            이벤트 공지란
          </div>
        </div>
      </div>
    </div>
  );
}

export default DetailHeader;
